// src/api/announcementApi.ts
import api from './api';
import { Announcement } from '../types/announcement';

const announcementApi = {
  // Currently-showing announcements for the header (every logged-in user).
  getActive: async (): Promise<Announcement[]> => {
    const res = await api.get('/announcements/active');
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  },

  // Management list (managers see all; others see active only).
  getAll: async (): Promise<Announcement[]> => {
    const res = await api.get('/announcements/');
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  },

  getById: async (id: string): Promise<Announcement> => {
    const res = await api.get(`/announcements/${id}`);
    return res.data;
  },

  // Manage-gated on the backend (403 otherwise).
  create: async (data: Omit<Announcement, 'id'>): Promise<Announcement> => {
    const res = await api.post('/announcements/', data);
    return res.data;
  },

  update: async (id: string, data: Partial<Announcement>): Promise<Announcement> => {
    const res = await api.put(`/announcements/${id}`, data);
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/announcements/${id}`);
  },
};

export default announcementApi;

// ---------------------------------------------------------------------------
// Bell feed - automatic announcement notices (today: upcoming birthdays).
// Same contract as the attendance / asset / expense feeds the bell merges.
// ---------------------------------------------------------------------------
export interface AnnouncementNotification {
  id: string;
  kind: string; // BIRTHDAY
  source: string; // "announcement"
  announcement_id: string | null;
  on_date: string | null;
  task_id: string; // "announcement:<announcement_id>"
  title: string;
  body: string | null;
  is_read: boolean;
  created_at: string;
}

export const getAnnouncementNotifications = (limit = 50) =>
  api.get<{ total: number; items: AnnouncementNotification[] }>(
    `/announcements/notifications/unread?limit=${limit}`,
  );

export const markAnnouncementNotificationRead = (id: string) =>
  api.post(`/announcements/notifications/${id}/read`);
